import AnalyticsContainer from './Analytics.container';
export default AnalyticsContainer;
